<template>
  <form-layout :title="'Choix de votre profil :'" :nameLink="'Pourquoi avons-nous besoin de cette information ?'" :href="'/info/pourquoi-avons-nous-besoin-de-votre-profil'" :hasLink="true">

    <slot>
      <ul>
        <choice v-for="(answer, index) in profiles" :key="index" :type="'radio'" :answer="answer" :idBtn="index"/>
      </ul>

      <div class="u-color--red prevent-error" v-if="submitted && getAnswerSelected === false">
        <img src="@/assets/img/icons.svg#icon-error" width="20" height="20">
        <span>Veuillez rentrer un profil</span></div>
      <cgu :submitted="submitted"/>

      <div class="col-12 d-flex justify-content-center button">
        <v-button-round :text="'Valider votre profil'" class="u-bg--skin" @click.native="saveProfile()"/>
      </div>
    </slot>

  </form-layout>
</template>

<script>
  import FormLayout from './../Layout/FormLayout'

  import Choice from './Parts/Choice/Choice'
  import Cgu from "./Parts/Choice/Granular/Cgu";
  import VButtonRound from "./../Core/RoundButton";

  import { mapGetters } from 'vuex'

  export default {
    name: "FormProfiles",
    data: () => {
      return {
        submitted: false
      }
    },
    methods: {
      saveProfile() {
        this.submitted = true

        if (this.getAnswerSelected !== false && this.getCguStatus) {
          var profile = this.profiles[this.getAnswerSelected].node.title;
          this.$cookies.set('profile', profile)

          // Analytics
          if (typeof _paq != "undefined") {
            _paq.push(['setCustomDimension', '1', profile]);
          }

          this.$emit('formProfileSubmitted');
        }
      }
    },
    computed: {
      showErrorProfile() {
        return
      },
      ...mapGetters({
        getCguStatus: 'getCguStatus',
        getAnswerSelected: 'getAnswerSelected',
        profiles: 'getProfiles'
      })
    },
    components: {VButtonRound, Cgu, Choice, FormLayout}
  }
</script>

<style lang="scss">
  .profil-choice {
    padding: 0 rem(30px) rem(40px);

    ul {
      padding: 0;
    }

    @include mq($until: MD) {
      padding: rem(10px) rem(20px);
    }
  }
</style>
